<script setup lang="ts">
import type { Article } from "~/types/article"
import { vOnClickOutside } from "@vueuse/components"

defineProps<{ data: Article }>()

const showCaption = ref(false)
</script>

<template>
  <div v-if="data?.imageCaption?.html" class="image-caption">
    <Transition name="fade" mode="out-in">
      <div
        v-if="showCaption"
        id="image-caption"
        v-on-click-outside.bubble="() => (showCaption = false)"
        class="absolute bottom-0 right-0 z-10 w-full bg-black/50 p-10 py-5 !font-national2 text-[--theme-lightest] backdrop-blur-sm"
      >
        <div class="mb-20">
          <div class="flex w-full justify-end">
            <UButton
              variant="quite"
              theme="white"
              @click="showCaption = false"
            >
              <template #prepend>
                <UIcon name="close" />
              </template>
            </UButton>
          </div>
          <component
            :is="{
              name: 'richtext',
              template: data?.imageCaption?.html,
            }"
          />
        </div>
      </div>
    </Transition>

    <div
      v-if="!showCaption"
      class="absolute bottom-2 right-2 md:bottom-0 md:right-0"
    >
      <UButton
        v-model:active="showCaption"
        :aria-expanded="showCaption"
        aria-controls="image-caption"
        data-pendo="image-caption"
        class="m-3"
        pill
        size="sm"
        variant="filled"
        @click.stop
      >
        <template #prepend>
          <UIcon name="camera" />
        </template>
        Bildetekst
      </UButton>
    </div>
  </div>
</template>
